export default d => d;